/*
 * @providesModule SignUpStyleLegacy
 */

import {StyleSheet, Dimensions, Platform} from 'react-native';
import Sizes from 'Sizes';

const backgroundWidth = Dimensions.get('screen').width * 1.3;
const backgroundHeightDivider = Sizes.isTablet() ? 3.78 : Platform.OS == 'ios' ? 3.2 : 2.45;
const buttonWidth = Sizes.isTablet() ? 374 : 311;
const regularFontSize = Sizes.isTablet() ? 19 : 16;
const regularLineHeight = Sizes.isTablet() ? 28 : 20;
let backgroundHeight = Dimensions.get('screen').height / backgroundHeightDivider;
if (backgroundHeight < 250) {
  backgroundHeight = 256;
}

export default StyleSheet.create({
  headerText: {
    position: 'absolute',
    bottom: Sizes.isTablet() ? 25 : 16,
    alignSelf: 'center',
    fontFamily: 'OpenSans-Bold',
    fontSize: Sizes.isTablet() ? 22 : 20,
    color: 'rgba(0, 0, 0, 0.9)',
  },

  headerContainer: {
    borderBottomColor: 'rgba(0, 0, 0, 0.2)',
    borderBottomWidth: 1,
    width: '100%',
    height: Sizes.isTablet() ? 100 : 64,
    flexDirection: 'row',
    justifyContent: 'center',
  },

  background: {
    width: backgroundWidth,
    height: backgroundHeight,
    alignSelf: 'center',
    position: 'absolute',
    marginTop: Sizes.isTablet() ? 0 : -4,
  },

  saveAccountContainer: {
    alignSelf: 'center',
    marginLeft: Sizes.isTablet() ? -25 : -18,
    flexDirection: 'row',
    marginTop: Sizes.isTablet() ? 20 : 16,
    marginBottom: 16,
    alignItems: 'flex-end',
  },

  saveAccountIconContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: Sizes.isTablet() ? 25 : 18,
    alignItems: 'center',
  },

  imageText: {
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 14 : 12,
    color: 'rgba(0, 0, 0, 0.9)',
  },

  orText: {
    fontSize: Sizes.isTablet() ? 14 : 12,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#757575',
  },

  loginText: {
    lineHeight: regularLineHeight,
    fontSize: regularFontSize,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#ffffff',
  },

  skillzLogo: {
    marginTop: Sizes.isTablet() ? -2 : -1,
    width: Sizes.isTablet() ? 102 : 70,
    height: Sizes.isTablet() ? 28 : 20,
  },

  skillzSignUpText: {
    fontSize: regularFontSize,
    lineHeight: regularLineHeight,
    fontStyle: 'normal',
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0, 0, 0, 0.9)',
  },

  skillzSignUpTextContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: Sizes.isTablet() ? 19 : 20,
    marginBottom: Sizes.isTablet() ? 1 : 0,
  },

  saveAccountText: {
    fontSize: Sizes.isTablet() ? 22 : 18,
    alignSelf: 'center',
    marginTop: 32,
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0, 0, 0, 0.9)',
  },

  firstDepostText: {
    fontSize: Sizes.isTablet() ? 22 : 18,
    alignSelf: 'center',
    marginTop: 24,
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0, 0, 0, 0.9)',
  },

  saveAccountToText: {
    fontSize: regularFontSize,
    alignSelf: 'center',
    fontFamily: 'OpenSans-Regular',
    color: 'rgba(0, 0, 0, 0.9)',
  },

  container: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    height: '100%',
    ...Platform.select({
      web: {
        width: '100%',
      },
    }),
  },

  containerScrollview: {
    backgroundColor: '#ffffff',
    width: '100%',
    height: '100%',
  },

  inputView: {
    marginTop: 16,
    marginBottom: Sizes.isTablet() ? 4 : 0,
    height: Sizes.isTablet() ? 77 : 64,
    width: buttonWidth,
    borderColor: 'rgba(0, 0, 0, 0.4)',
    borderWidth: 1,
    borderRadius: 9,
    flexDirection: 'row',
    alignSelf: 'center',
    backgroundColor: '#ffffff',
  },

  textInputEmail: {
    width: '90%',
    height: '100%',
  },

  textInputPassword: {
    width: '100%',
    height: '100%',
  },

  inputHighlight: {
    marginTop: 16,
    marginBottom: Sizes.isTablet() ? 4 : 0,
    height: Sizes.isTablet() ? 77 : 64,
    width: buttonWidth,
    borderColor: '#4890E8',
    borderWidth: 2,
    borderRadius: 9,
    flexDirection: 'row',
    alignSelf: 'center',
    backgroundColor: '#ffffff',
  },

  inputError: {
    marginTop: 16,
    alignSelf: 'center',
    marginBottom: Sizes.isTablet() ? 4 : 0,
    height: Sizes.isTablet() ? 77 : 64,
    width: buttonWidth,
    borderColor: '#DD6952',
    borderWidth: 2,
    borderRadius: 9,
    flexDirection: 'row',
    backgroundColor: '#ffffff',
  },

  labelTextError: {
    color: '#DD6952',
    fontSize: Sizes.isTablet() ? 14 : 12,
    left: Sizes.isTablet() ? 15 : 12,
    fontFamily: 'OpenSans-SemiBold',
  },

  fedDivider1: {
    alignSelf: 'center',
    borderBottomColor: '#000000',
    borderBottomWidth: 1,
    opacity: 0.4,
    width: Sizes.isTablet() ? 168 : 138,
    marginStart: 8,
  },
  fedDivider: {
    alignSelf: 'center',
    borderBottomColor: '#000000',
    borderBottomWidth: 1,
    opacity: 0.4,
    width: Sizes.isTablet() ? 168 : 138,
    marginEnd: 8,
  },

  signInBtn: {
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 16 : 14,
    color: '#4890e8',
  },

  haveAccountContainer: {
    alignSelf: 'center',
    flexDirection: 'row',
    lineHeight: 20,
    marginBottom: 12,
  },

  haveAccountText: {
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 16 : 14,
    color: '#757575',
  },

  fedLoginText: {
    fontSize: regularFontSize,
    lineHeight: regularLineHeight,
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0,0,0,.9)',
    alignSelf: 'center',
  },

  fedLoginBtn: {
    width: buttonWidth,
    height: Sizes.isTablet() ? 58 : 48,
    borderColor: 'rgba(0, 0, 0, 0.4)',
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderRadius: 100,
    flexDirection: 'row',
    alignSelf: 'center',
  },

  fedLoginBtnSpacing: {
    height: Sizes.isTablet() ? 20 : 16,
  },

  fedLoginBtnContainer: {
    marginTop: 16,
    maxHeight: Sizes.isTablet() ? 214 : 176,
  },

  loginBtn: {
    width: buttonWidth,
    borderRadius: Sizes.isTablet() ? 29 : 24,
    height: Sizes.isTablet() ? 58 : 48,
    marginBottom: Sizes.isTablet() ? 32 : 16,
    marginTop: 24,
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: '#4890E8',
  },

  closeBtn: {
    alignSelf: 'center',
    position: 'absolute',
    bottom: Sizes.isTablet() ? 24 : 16,
    right: Sizes.isTablet() ? 44 : 22,
  },

  closeIcons: {
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 30 : 24,
  },

  placeHolderText: {
    left: Sizes.isTablet() ? 15 : 12,
    color: '#757575',
    fontSize: regularFontSize,
    fontFamily: 'OpenSans-SemiBold',
  },

  labelTextHighlight: {
    color: '#4890E8',
    alignItems: 'center',
    fontSize: Sizes.isTablet() ? 14 : 12,
    left: Sizes.isTablet() ? 15 : 12,
    fontFamily: 'OpenSans-SemiBold',
  },

  labelText: {
    color: '#757575',
    fontSize: Sizes.isTablet() ? 14 : 12,
    left: Sizes.isTablet() ? 15 : 12,
    fontFamily: 'OpenSans-SemiBold',
  },

  passwordIcon: {
    marginRight: Sizes.isTablet() ? 23 : 12,
    marginLeft: 8,
    top: 2,
    tintColor: 'rgba(0,0,0,.3)',
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 29 : 24,
  },

  googleIcon: {
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 30 : 24,
    marginLeft: Sizes.isTablet() ? 14 : 13.5,
    marginRight: 37,
    marginTop: Sizes.isTablet() ? 14 : 12,
    justifyContent: 'flex-start',
  },

  facebookIcon: {
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 30 : 24,
    marginRight: Sizes.isTablet() ? 24 : 27,
    marginLeft: Sizes.isTablet() ? 14 : 13.5,
    marginTop: Sizes.isTablet() ? 15 : 12,
    justifyContent: 'flex-start',
  },

  appleIcon: {
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 30 : 24,
    marginLeft: 12,
    marginRight: Sizes.isTablet() ? 45 : 40.5,
    marginTop: Sizes.isTablet() ? 14 : 12,
    justifyContent: 'flex-start',
  },

  textInInput: {
    left: 12,
    fontSize: 16,
    fontFamily: 'OpenSans-Regular',
  },

  orContainer: {
    flexDirection: 'row',
    height: Sizes.isTablet() ? 20 : 16,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
  },

  rewardsIcon: {
    width: Sizes.isTablet() ? 48 : 40,
    height: Sizes.isTablet() ? 42 : 35,
    marginBottom: Sizes.isTablet() ? 4 : 6.44,
  },

  customerSupportIcon: {
    width: Sizes.isTablet() ? 56 : 46,
    height: Sizes.isTablet() ? 45 : 36,
    marginBottom: Sizes.isTablet() ? 3 : 6,
  },

  ribbonIcon: {
    width: Sizes.isTablet() ? 46 : 38,
    height: Sizes.isTablet() ? 56 : 47,
    marginBottom: Sizes.isTablet() ? 0 : 0.84,
  },

  errorMessage: {
    fontSize: Sizes.isTablet() ? 14 : 12,
    color: 'rgba(221, 105, 82, 1)',
    fontFamily: 'OpenSans-SemiBold',
    marginLeft: Sizes.isTablet() ? 5.5 : 5.33,
  },

  errorContainer: {
    flexDirection: 'row',
    width: buttonWidth,
    marginTop: 4,
    alignSelf: 'center',
  },

  errorIcon: {
    height: 16,
    width: 16,
  },
});
